module.exports = "<my-dispatch-edit-form my-dispatch=\"$$dispatch.data.myDispatch\"\n  enable-title=\"true\"\n  enable-back=\"true\">\n</my-dispatch-edit-form>\n"


//////////////////
// WEBPACK FOOTER
// ./public/javascript/sygem/routing/consult/dispatch/templates/edit.html
// module id = 1494
// module chunks = 0